export default "__VITE_ASSET__BTdeAeZA__"